// @ts-nocheck
import { I18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { type FC } from 'react'
import { useSelector } from 'react-redux'
import { compose } from 'redux'

import { SA_SELLER_ID } from 'shared/consts/checkout'
import { PRESCRIPTION_TYPES } from 'shared/consts/productTemplates'
import { TENANT_AT, TENANT_IT } from 'shared/consts/tenants'
import { withI18n } from 'shared/utils/withI18n'
import { type IState } from 'types/redux/store'
import Price from 'views/components/atoms/Price'
import ImageRow from 'views/components/molecules/ImageRow'
import Notification from 'views/components/molecules/Notification'
import { redeemedRedPointsSelector } from 'views/components/organisms/Cart/selectors'
import Tenant from 'views/components/utils/Tenant'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

import './RedPointsInformationModalContent.scss'

type Props = {
  i18n: I18n
}

const RedPointsInformationModalContent: FC<Props> = ({ i18n }) => {
  const { data: cart } = useSelector((state: IState) => state.cart)

  const totalRedeemedRedpointsAmount = useSelector(redeemedRedPointsSelector)

  if (cart === null) {
    return null
  }

  function getNoPrescriptionItems(groupEntries) {
    return (
      groupEntries.find(
        entry => entry.type === PRESCRIPTION_TYPES.NO_PRESCRIPTION
      )?.items || []
    )
  }

  function getRedPointProducts(groupEntries) {
    return getNoPrescriptionItems(groupEntries)
      .filter(item => item.discountable)
      .map(item => ({
        id: item.offerId,
        imageUrl: item.imageUrl,
        name: item.productName,
      }))
  }

  cart.sellerGroups.sort(sellerGroupA =>
    sellerGroupA.sellerId === SA_SELLER_ID ? -1 : 0
  )
  return (
    <>
      <Tenant not tenant={[TENANT_AT, TENANT_IT]}>
        {() => (
          <div className="u-margin-large--bottom">
            <Notification
              label={
                <Trans id="cart.redPointsModal.descriptionTextForRedPointsProducts" />
              }
            />
          </div>
        )}
      </Tenant>
      {cart.sellerGroups.map(sellerGroup => (
        <div
          key={sellerGroup.sellerId}
          className="u-padding-large u-background-color--background u-border-radius u-margin--bottom"
        >
          {sellerGroup.sellerId !== SA_SELLER_ID && (
            <div className="l-flex l-flex--distribute-space l-flex--vertical-stretch@small-tiny">
              <div className="u-color--grey a-h3 u-no-margin o-RedPointsInformationModalContent__SellerName">
                <Trans
                  id="checkout.ShipmentBySeller.seller"
                  values={{ seller: sellerGroup.sellerName }}
                />
              </div>
              <div className="u-color--red a-h4 u-font-weight--bold u-no-margin">
                <Trans id="checkout.verification.redPointsModal.excludedFromRedPointsProgram" />
              </div>
            </div>
          )}
          {sellerGroup.sellerId === SA_SELLER_ID && (
            <>
              <div className="u-color--dark a-h3 u-no-margin">
                <Trans
                  id="checkout.ShipmentBySeller.seller"
                  values={{ seller: sellerGroup.sellerName }}
                />
              </div>
              <div className="u-color--grey u-padding--bottom">
                <Trans id="redPointsModal.redeemedRedPoints.forProducts.subText.headline" />
              </div>
              <div className="u-no-padding o-modalBox-rightContent u-padding-large--bottom u-border--bottom@medium u-border-color--greySky">
                <ImageRow
                  items={getRedPointProducts(sellerGroup.groupEntries)}
                  keepImageSize
                />
              </div>
              <ul className="a-list-reset l-flex o-modalBox-rightContent u-padding-small--bottom u-padding-large--top@medium u-font-weight--bold">
                <li>
                  <TransWithHtml text={i18n._('basket.subTotal')} />
                </li>
                <li>
                  <Price
                    amount={sellerGroup.subAmount}
                    currency={cart.currency}
                  />
                </li>
              </ul>
              <ul className="a-list-reset l-flex o-modalBox-rightContent u-padding-small--bottom">
                <li>
                  {totalRedeemedRedpointsAmount * 1000}{' '}
                  <Trans id="general.label.redPoints" />
                </li>
                <li className="u-color--positive">
                  -{' '}
                  <Price
                    amount={totalRedeemedRedpointsAmount}
                    symbolLeft
                    decimalPlaces={2}
                  />
                </li>
              </ul>
            </>
          )}
        </div>
      ))}
    </>
  )
}

export default compose(
  withShopAndRuntimeConfig,
  withI18n()
)(RedPointsInformationModalContent)
